import React from "react"
import { ElementLoader } from "@ciq/shared/components/element_loader"
import { SplitLayout } from "@ciq/shared/components/split_layout"

import { MapLeftPane } from "./components/leftPane/view"
import { Overlay } from "./components/overlays/overlay"
import { MapRightPane } from "./components/rightPane/view"
import { Map } from "./components/map/view"

import { MapViewDataProvider, useMapViewData } from "./hooks/map_view_data"

export function MapView(props) {
  const { children } = props

  return (
    <MapViewDataProvider>
      <View>{children}</View>
    </MapViewDataProvider>
  )
}

function View(props) {
  const { view } = useMapViewData()
  const { hasResource, isHidingLeftPane, toggleLeftPane, isHidingRightPane, toggleRightPane } = view
  const { children } = props

  return (
    <>
      <ElementLoader elementId="map-content">
        <Map />
      </ElementLoader>
      <SplitLayout
        hasDetailResource={hasResource}
        leftPaneClassName="map-split-layout"
        isHidingLeftPane={isHidingLeftPane}
        toggleLeftPane={toggleLeftPane}
        rightPaneClassName="map-split-layout"
        isHidingRightPane={isHidingRightPane}
        toggleRightPane={toggleRightPane}
        showHideButtons={true}
        // cycleDatasource={() => {
        //   console.info("cycleDatasource called")
        // }}
        // onOpenResource={() => {
        //   console.info("onOpenResource called")
        // }}
      >
        <MapLeftPane />
        <Overlay />
        <MapRightPane>{children}</MapRightPane>
      </SplitLayout>
    </>
  )
}
